"use client"

import { useRef, useEffect } from "react"
import { motion } from "framer-motion"
import ChatHeader from "./ChatHeader"
import MessageList from "./MessageList"
import MessageInput from "./MessageInput"

export default function ChatWindow({
  activeChatData,
  isConnected,
  messages,
  userData,
  message,
  setMessage,
  handleSendMessage,
  setShowChatsView,
}) {
  const messagesEndRef = useRef(null)



  useEffect(() => {
    // Scroll to bottom when messages change
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" })
  }, [messages])

  return (
    <div
      className="flex flex-col w-full bg-white"
      
    >
      <ChatHeader activeChatData={activeChatData} isConnected={isConnected} setShowChatsView={setShowChatsView} />

      <MessageList messages={messages} userData={userData} messagesEndRef={messagesEndRef} />

      <MessageInput message={message} setMessage={setMessage} handleSendMessage={handleSendMessage} />
    </div>
  )
}

